import * as React from 'react';

interface IProps {
}

export default class WidgetPrintWrapper extends React.Component<IProps, void> {
    static propTypes = {
    };

    render() {
        return (
            <div className="panel panel-default">
                <div className="panel-body">
                    {this.props.children}
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/widgetCanvas/WidgetPrintWrapper.tsx